var _path, _path2, _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgArrrowRightFilled(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 23,
    height: 23,
    viewBox: "0 0 23 23",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M10.095 6.11839C10.5236 6.11839 10.9459 6.2588 11.2808 6.53069L15.921 10.2996C16.2922 10.6001 16.5052 11.033 16.5052 11.4855C16.5052 11.9381 16.2922 12.371 15.9219 12.6715L11.2808 16.4395C10.7275 16.8903 9.93851 16.9806 9.27056 16.672C8.68087 16.3984 8.31504 15.8555 8.31504 15.2535L8.31504 7.71753C8.31504 7.11562 8.68087 6.57273 9.27056 6.29905C9.53355 6.17742 9.81566 6.11839 10.095 6.11839Z",
    fill: "#231F20"
  })), /*#__PURE__*/React.createElement("mask", {
    id: "mask0_2844_6957",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 8,
    y: 6,
    width: 9,
    height: 11
  }, _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M10.095 6.11839C10.5236 6.11839 10.9459 6.2588 11.2808 6.53069L15.921 10.2996C16.2922 10.6001 16.5052 11.033 16.5052 11.4855C16.5052 11.9381 16.2922 12.371 15.9219 12.6715L11.2808 16.4395C10.7275 16.8903 9.93851 16.9806 9.27056 16.672C8.68087 16.3984 8.31504 15.8555 8.31504 15.2535L8.31504 7.71753C8.31504 7.11562 8.68087 6.57273 9.27056 6.29905C9.53355 6.17742 9.81566 6.11839 10.095 6.11839Z",
    fill: "white"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_2844_6957)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 22.4202,
    y: 22.2181,
    width: 21.8404,
    height: 21.465,
    transform: "rotate(-180 22.4202 22.2181)",
    fill: "#97144D"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgArrrowRightFilled);
export default __webpack_public_path__ + "static/media/arrrow-right-filled.d49124c82eb3d0785fd5af3e4228f288.svg";
export { ForwardRef as ReactComponent };